// src/cards/cardRegistry.js
import ChartCard from "./display/ChartCard";
import CronCard from "./trigger/CronCard";
import KVCard from "./display/KVCard";
import LogCard from "./display/LogCard";
import LoghookCard from "./display/LoghookCard";
import MediaCard from "./display/MediaCard";
import MessageEventCard from "./trigger/MessageEventCard";
import NotificationCard from "./action/NotificationCard";
import ReminderCard from "./display/ReminderCards";
import RequestCard from "./action/RequestCard";
import StatusCard from "./display/StatusCard";
import TopicCard from "./display/TopicCard";
import UrlCard from "./display/UrlCard";

export const cardRegistry = {
  display: {
    auto: {
      component: null,
      variants: ["default"],
      parameters: {},
    },
    status: {
      component: StatusCard,
      variants: StatusCard.variants,
      parameters: StatusCard.variantParameters,
    },
    loghook: {
      component: LoghookCard,
    },
    log: {
      component: LogCard,
      variants: LogCard.variants,
      parameters: LogCard.variantParameters,
    },
    url: {
      component: UrlCard,
      variants: UrlCard.variants,
      parameters: UrlCard.variantParameters,
    },
    chart: {
      component: ChartCard,
      variants: ChartCard.variants,
      parameters: ChartCard.variantParameters,
    },
    image: {
      component: MediaCard,
      variants: MediaCard.variants,
      parameters: MediaCard.variantParameters,
    },
    video: {
      component: MediaCard,
      variants: MediaCard.variants,
      parameters: MediaCard.variantParameters,
    },
    mapping: {
      component: KVCard,
      variants: KVCard.variants,
      parameters: KVCard.variantParameters,
    },
    text: {
      component: TopicCard,
      variants: TopicCard.variants,
      parameters: TopicCard.variantParameters,
    },
    reminder: {
      component: ReminderCard,
      variants: ReminderCard.variants,
      parameters: ReminderCard.variantParameters,
    },
  },

  trigger: {
    message: {
      component: MessageEventCard,
      variants: MessageEventCard.variants,
      parameters: MessageEventCard.variantParameters,
    },
    cron: {
      component: CronCard,
      variants: CronCard.variants,
      parameters: CronCard.variantParameters,
    },
  },

  action: {
    storage: {
      component: null,
      variants: ["database"],
      parameters: {},
    },
    notification: {
      component: NotificationCard,
      variants: NotificationCard.variants,
      parameters: NotificationCard.variantParameters,
    },
    request: {
      component: RequestCard,
      variants: RequestCard.variants,
      parameters: RequestCard.variantParameters,
    },
  },
};
